module.exports = __webpack_public_path__ + "img/ptz.feec81de.jpg";